var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 46,
    viewBox: "0 0 83 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4131 38.8085C20.4131 37.9348 21.1213 37.2266 21.995 37.2266H59.4872C60.3609 37.2266 61.0691 37.9348 61.0691 38.8085V43.0798C61.0691 43.9534 60.3609 44.6617 59.4872 44.6617H21.995C21.1213 44.6617 20.4131 43.9534 20.4131 43.0798V38.8085Z",
    fill: "#FAD3D8",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01032 4.29156C0.863739 2.49793 2.29715 1 4.09677 1H78.901C80.8382 1 82.3141 2.72385 81.9424 4.62513C81.5499 6.63322 81.0019 9.10761 80.3687 11.0454C79.0868 14.9683 78.1339 17.5471 76.0184 21.0907C73.7399 24.9073 72.2567 26.7044 69.1369 29.8705C66.7292 32.314 62.3375 36.2622 60.4581 37.9374C59.8826 38.4503 59.1407 38.7294 58.3697 38.7294H23.1806C22.5128 38.7294 21.8622 38.5185 21.3258 38.1206C19.4837 36.7543 15.0039 33.3701 12.4241 30.8988C9.11893 27.7326 7.30125 25.1291 5.14714 21.0907C3.25806 17.5492 2.75361 14.9683 1.90415 11.0454C1.46101 8.99884 1.17886 6.35375 1.01032 4.29156Z",
    fill: "#FAD3D8",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.0742,
    y: 25.8366,
    width: 10.2827,
    height: 2.21473,
    rx: 1.10736,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.0345,
    cy: 17.8477,
    r: 2.45202,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.6053,
    cy: 17.8477,
    r: 2.45202,
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupIcon);
export default __webpack_public_path__ + "static/media/CupIcon.cc42cbbd.svg";
export { ForwardRef as ReactComponent };